var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.418 17.4863H30.3174L30.1602 16.0645C29.4355 9.59766 23.9805 4.7168 17.4658 4.7168C10.418 4.7168 4.68262 10.4521 4.68262 17.5C4.68262 20.0156 5.4209 22.4561 6.82227 24.5615L7.19824 25.1289H13.3301L16.7412 30.2832H30.167V21.335H17.418V17.4863ZM8.59961 22.5723C7.71094 21.0273 7.23926 19.2842 7.23926 17.5C7.23926 11.8604 11.8262 7.27344 17.4658 7.27344C22.1895 7.27344 26.2158 10.4795 27.3574 14.9297H14.8613V22.5723H14.7041L13.4189 20.6309L11.2861 22.0391L11.6416 22.5723H8.59961ZM27.6104 27.7266H23.8506V23.8916H27.6104V27.7266ZM21.3008 23.8916V27.7266H18.1152L16.3994 25.1289H17.4248V23.8916H21.3008Z",
    fill: "#14171F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0743 20.0566C11.7803 20.0566 12.3527 19.4843 12.3527 18.7783C12.3527 18.0723 11.7803 17.5 11.0743 17.5C10.3683 17.5 9.79602 18.0723 9.79602 18.7783C9.79602 19.4843 10.3683 20.0566 11.0743 20.0566Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanFootball);
export default __webpack_public_path__ + "static/media/american-football.b01d6237db91091998e6fbd1910e5b9b.svg";
export { ForwardRef as ReactComponent };